import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-submission',
  templateUrl: './view-submission.component.html',
  styleUrls: ['./view-submission.component.css']
})
export class ViewSubmissionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
